import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialProps {
  name: string;
  location: string;
  text: string;
}
const TestimonialCard = ({
  name,
  location,
  text
}: TestimonialProps) => <div className="bg-brand-card p-3.5 rounded-xl border border-white/5 flex flex-col h-full hover:border-brand-accent/50 transition-all duration-300" data-id="element-306">
    <div className="flex items-center mb-2" data-id="element-307">
      <div className="w-9 h-9 bg-brand-accent text-white rounded-full flex items-center justify-center font-black text-base mr-2.5 shrink-0" data-id="element-308">
        {name.charAt(0)}
      </div>
      <div data-id="element-309">
        <div className="flex text-brand-accent mb-0.5" data-id="element-310">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-current" data-id="element-311" />)}
        </div>
        <p className="font-black text-white text-sm leading-tight" data-id="element-312">{name}</p>
        <p className="text-[10px] text-gray-400 font-medium" data-id="element-313">📍 {location}</p>
      </div>
    </div>
    <p className="text-gray-300 text-xs md:text-sm italic flex-grow leading-relaxed font-medium" data-id="element-314">
      "{text}"
    </p>
  </div>;
export function TestimonialsSection2() {
  const testimonials = [{
    name: 'Marcelo D.',
    location: 'Rosario | Escuela Técnica N°2 — Informática y Programación',
    text: 'Por fin tengo ejercicios de Python pensados para la secundaria técnica. Antes buscaba en tutoriales en inglés y adaptaba durante horas. Ahora entro al laboratorio con la guía lista y los alumnos programan desde el primer módulo.'
  }, {
    name: 'Graciela P.',
    location: 'Buenos Aires | Maestra de Taller — Informática Industrial',
    text: 'El tomo de lógica y pseudocódigo me cambió las clases. Los chicos entendieron la estructura de un programa con las actividades incluidas. Antes les explicaba en el pizarrón y no quedaba nada. Ahora lo escriben ellos.'
  }, {
    name: 'Diego F.',
    location: 'Córdoba | Profesor de Programación — 5° y 6° año Técnica',
    text: 'Mis alumnos nunca entendían para qué servía aprender a programar. Con el Tomo 4 y los proyectos reales, lo resolvieron ellos mismos en el laboratorio y no lo olvidaron más. Fue un antes y un después en mis clases.'
  }, {
    name: 'Adriana L.',
    location: 'Tucumán | Docente de Informática — Técnica Industrial',
    text: 'Los proyectos del upsell me salvaron el cierre de año. Tenía 3 grupos en distintos niveles y necesitaba propuestas diferentes para cada uno. Ya los tenía todos listos con sus rúbricas. No inventé absolutamente nada.'
  }, {
    name: 'Hernán V.',
    location: 'Mendoza | Profesor de Prácticas Profesionalizantes',
    text: 'El banco de actividades es espectacular. Mis alumnos de 4to año pasaron de no entender qué era una variable a programar calculadoras en Python en un solo trimestre. Me ahorró horas de planificación y dolores de cabeza.'
  }];
  return <section className="py-6 md:py-12 px-3 bg-brand-dark" data-id="element-315">
      <div className="max-w-5xl mx-auto" data-id="element-316">
        <h2 className="text-xl md:text-3xl font-black text-center mb-5 text-white" data-id="element-317">
          ❤️ LO QUE DICEN LOS DOCENTES QUE YA LO TIENEN
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-318">
          {testimonials.map((t, i) => <div key={i} className={i === 4 ? 'md:col-span-2 lg:col-span-1' : ''} data-id="element-319">
              <TestimonialCard {...t} data-id="element-320" />
            </div>)}
        </div>
      </div>
    </section>;
}